export default __webpack_public_path__ + "static/media/pixate.c6c83ad7.svg";